import type { CSSProperties } from 'react';

export default function HeadingView(props: {
    text: string;
    style?: CSSProperties;
    className?: string;
}): JSX.Element {
    return (
        <h4 className={props.className ?? ''} style={props.style}>
            {props.text}
        </h4>
    );
}
